var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleInverted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7725 6.83333L10.0683 14.5742C9.93229 14.7547 9.72944 14.8729 9.50535 14.9024C9.28126 14.9318 9.05473 14.87 8.87666 14.7308L4.80333 11.4742C4.44388 11.1865 4.38568 10.6619 4.67333 10.3025C4.96098 9.94305 5.48555 9.88485 5.845 10.1725L9.24166 12.89L14.4308 5.8475C14.601 5.59216 14.8977 5.45099 15.2032 5.48003C15.5086 5.50908 15.7734 5.70364 15.8924 5.98648C16.0114 6.26931 15.9653 6.59465 15.7725 6.83333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleInverted);
export default __webpack_public_path__ + "static/media/check-circle-inverted.78c03cd9ef9bdaa2943ff2a2f4ea87a4.svg";
export { ForwardRef as ReactComponent };